import React, { useEffect } from "react";

export default function ServerError() {
    useEffect(() => {
        let meta = document.querySelector('meta[name="robots"]');

        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "robots");
            document.head.appendChild(meta);
        }

        meta.setAttribute("content", "noindex, nofollow");

        return () => {
            meta.setAttribute("content", "index, follow");
        };
    }, []);

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <div style={styles.iconWrapper}>
                    <span style={styles.code}>500</span>
                </div>

                <h1 style={styles.title}>Internal Server Error</h1>

                <p style={styles.description}>
                    Something went wrong while processing your request.
                    Our team has been notified and is working to resolve the issue.
                </p>

                <div style={styles.actions}>
                    {/*<button*/}
                    {/*    type="button"*/}
                    {/*    onClick={handleRetry}*/}
                    {/*    style={styles.primaryButton}*/}
                    {/*>*/}
                    {/*    Try Again*/}
                    {/*</button>*/}

                    <a href="/" style={styles.secondaryButton}>
                        Return Home
                    </a>
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f8fafc",
        fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },

    card: {
        width: "100%",
        maxWidth: "520px",
        background: "#ffffff",
        borderRadius: "22px",
        padding: "48px 40px",
        textAlign: "center",
        border: "1px solid #e5e0d3",
        boxShadow:
            "0 24px 48px -20px rgba(25,24,23,0.25)",
    },

    iconWrapper: {
        width: "96px",
        height: "96px",
        margin: "0 auto 24px",
        borderRadius: "50%",
        background: "#fef2f2",
        border: "1px solid #fecaca",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    code: {
        color: "#dc2626",
        fontSize: "28px",
        fontWeight: 700,
        letterSpacing: "-1px",
    },

    title: {
        margin: "0 0 12px",
        fontSize: "32px",
        fontWeight: 700,
        color: "#0f172a",
        fontFamily: "'Space Grotesk', Inter, sans-serif",
        letterSpacing: "-0.02em",
        lineHeight: 1.2,
    },

    description: {
        margin: "0 auto 32px",
        color: "#64748b",
        fontSize: "16px",
        lineHeight: 1.7,
        maxWidth: "400px",
    },

    actions: {
        display: "flex",
        justifyContent: "center",
        gap: "12px",
        flexWrap: "wrap",
    },

    primaryButton: {
        appearance: "none",
        border: "none",
        cursor: "pointer",
        background: "#0f172a",
        color: "#ffffff",
        padding: "12px 20px",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: 600,
        minWidth: "140px",
    },

    secondaryButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        background: "#0f172a",
        color: "#f8fafc",
        padding: "12px 20px",
        borderRadius: "999px",
        fontSize: "14px",
        fontWeight: 700,
        minWidth: "140px",
        boxSizing: "border-box",
    },
};